
import { Global_Settings } from "../../api/global/Global";
import {
  FETCH_SETTING_DATA_REQUEST,
  FETCH_SETTING_DATA_SUCCESS,
  FETCH_SETTING_DATA_FAILURE
} from "../types"

export const fetchSettingData = () => async (dispatch, getState) => {
 const { settingdata } = getState();
  const { status } = settingdata;

  if (status === "pending") {
    return;
  }

   if (status === "success") {
    return;
  }

 

  dispatch({ type: FETCH_SETTING_DATA_REQUEST });
  try {
    const response = await Global_Settings();

    if (response?.data?.status == 200) {
      dispatch({
        type: FETCH_SETTING_DATA_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      dispatch({
        type: FETCH_SETTING_DATA_FAILURE,
        payload: "Failed to fetch setting data",
      });
    }
  } catch (error) {
    console.log("error", error);
    dispatch({
      type: FETCH_SETTING_DATA_FAILURE,
      payload: error.message,
    });
  }
};